export default {
  header: 'Pripnuté aplikácie',
  subheader: 'Presuňte aplikácie, ktoré sa majú zobrazovať na navigačnej lište, do zoznamu pripnutých aplikácií a usporiadajte ich v poradí, v akom sa tam majú zobrazovať.',
  pinnedApps: 'Pripnuté aplikácie',
  pinnedAppsEmpty: 'Presuňte sem aplikácie, ktoré chcete pripnúť.',
  availableApps: 'Dostupné aplikácie',
  availableAppsEmpty: 'Všetky dostupné aplikácie sú pripnuté. Presuňte sem aplikáciu, ktorú chcete odopnúť.',
};
